const sex = ["男:男", "女:女"];
let exportObj = {
  sex,
};

/**
 * json格式的类型,转为下拉框可用的array
 * @param addAll 是否添加[全部]选项
 */
const toSelect = function(type, addAll) {
  let typeArr = [];
  if (addAll) {
    let item = {
      value: -1,
      label: "全部",
    };
    typeArr.push(item);
  }
  for (let key in type) {
    let keyInt = parseInt(key);
    let item = {
      value: keyInt,
      label: type[key],
    };
    typeArr.push(item);
  }
  return typeArr;
};

const inspectionPercentage = {
  10: "10",
  20: "20",
  30: "30",
  40: "40",
  50: "50",
  60: "60",
  70: "70",
  80: "80",
  90: "90",
};
const inspectionType = {
  0: "值类型",
  1: "图片",
  2: "数据类型",
};
const inspectionMethod = {
  0: "全检",
  1: "免检",
  2: "抽检",
};

//PP_ProductionOrder（生产订单）
const productionStatus = {
  0: "计划",
  10: "已提交",
  20: "已审核",
  30: "已释放",
  40: "生产中",
  50: "已完工",
};
//PP_ProductionOrderMaterial（生产订单物料表）
const productionOrderMaterialStatus = {
  0: "未开工",
  10: "生产中",
  20: "完工",
};


const inspectionStation = {};
const departmentName = {
  0: "请选择",
  1: "总经办",
};
// 拧紧代码
const currentStatus = {
  0: "",
  1: "OK",
  2: "NG",
};

//紧急程度
const urgencyType = {
  10: "一般",
  20: "较急",
  30: "特急",
};

//故障修理方法
const faultDealMethod = {
  10: "内修",
  20: "外修",
};

//处理方法
const dealMethod = {
  10: "零配件更换",
  20: "设备调试",
  90: "其他",
};

//修理结果
const result = {
  10: "不可使用",
  20: "可以使用",
};

//状态
const reportOrderStatus = {
  10: "未提交",
  15: "负责待选择",
  20: "已提交",
  25: "待外修",
  30: "已修复",
  40: "已确认",
};//撤销状态
const repealStatus = {
  10: "撤销中",
  20: "拒绝撤销",
  30: "已撤销",
};
const customerTypeName = {
  0: "整梯",
  1: "工程",
};
const parentName = {
  0: "总经理",
  1: "总监",
  2: "会计",
  3: "出纳",
  4: "助理",
  5: "仓管员",
  6: "质管员",
  7: "销售员",
  8: "部门经理",
  9: "普通员工",
};
const category = {
  0: "内部用户",
  1: "外部用户",
};
const deliveryType = {
  0: "主动送货",
  1: "采购组通知",
};
const flowName = {
  0: "销售订单",
  1: "销售订单",
};
const status = {
  0: "启用",
  1: "禁用",
};

//sap 发货订单状态
const sapDeliveryStatus = {
  10: "已提交",
  40: "已出库",
  50: "已绑定",
  60: "已检验",
  70: "已发运",
  "-1": "未发运",
  "-2": "未完成出库",
  "-3": "部分出库",
  "-4": "未绑定",
};

const gender = {
  0: "男",
  1: "女",
};
const purchaseStatus = {
  0: "待提交",
  10: "待审核",
  15: "审核中",
  18: "待初检",
  30: "初检中",
  20: "待复检",
  40: "复检中",
  45: "待入库",
  50: "已入库",
  98: "退回",
};
const purchaseOrderStatus = {
  2: "正常",
  10: "暂停",
  20: "撤销",
};
const receiveStatus = {
  0: "全部",
  10: "部分到货",
  20: "已到货",
};
const receive = {
  0: "未创建",
  10: "部分创建",
  20: "已创建",
};

const snType = {
  10: "产品条码",
  20: "外箱条码",
};

const snStatus = {
  10: "待确认",
  20: "已确认",
  90: "已作废",
};

const nameplateType = {
  10: "产品铭牌",
  20: "外箱铭牌",
};

const materialSnStatus = {
  10: "待确认",
  20: "已确认",
  90: "已作废",
};

const mesStatus = {
  0: "待排产",
  10: "已排产",
  12: "已配料",
  14: "已上线",
  16: "已点检",
  18: "已备料",
  20: "贴片",
  21: "已贴片",
  22: "插件",
  23: "已插件",
  24: "喷胶",
  25: "已喷胶",
  26: "测试",
  27: "已测试",
  30: "组装",
  31: "已组装",
  32: "负载",
  33: "已负载",
  34: "老化",
  35: "已老化",
  36: "包装",
  37: "已包装",
  80: "已完工",
  90: "已入库",
};

const deliveryStatus = {
  10: "未回复",
  20: "已回复",
};

const checkStatus = {
  20: "待点检",
  25: "点检中",
  30: "已点检",
  40: "已点检",
};

const checksStatus = {
  10: "点检完成",
  20: "点检中",
  30: "点检失败",
  40: "待点检",
};

const colorType = {
  0: "红色",
  1: "橙色",
  2: "黄色",
  3: "绿色",
  4: "青色",
  5: "蓝色",
  6: "紫色",
  7: "粉色",
};

const approvalStatus = {
  0: "驳回",
  1: "通过",
};

const classes = {
  0: "白班",
  1: "夜班",
};

const employmentType = {
  1: "小时工",
  2: "正式工",
};

const isScrap = {
  10: "否",
  20: "是",
};

const moveType = {
  311: "",
  262: "",
};


const range = {
  0: "最新",
  1: "全部",
};

const CREDIT_GROUP = {
  1: "大客户",
  2: "小/中等客户",
  3: "关联客户",
};

const systemIds = {
  10: "内部",
  20: "外部",
};

// 客户分组
const customerGroup = {
  10: "一般客户",
  20: "大客户",
  30: "战略客户",
};

// 客户类型
const customerType = {
  11: "工程",
  12: "",
};

// 客户等级
const customerLevel = {
  1: "A+",
  2: "A",
  3: "B",
  4: "C",
};

// 销售订单类型
const salesOrderType = {
  10: "销售订单",
  20: "赠送订单",
  30: "借用订单",
  40: "样品订单",
};

// 销售订单状态
const salesOrderStatus = {
  10: "草稿",
  20: "已提交",
  999: "作废",
  12: "退单",
};

// 商务申请状态
const BusinessApplicationStatus = {
  2201: "未提交",
  2202: "待业务经理审核",
  2203: "通过",
  2204: "退回",
  2205: "作废",
  // 2206: "待营销中心审核",
  2207: "待财务审核",
  // 2208: "待销售总监审核",
  2209: "待总经理审核",
  // 2210: "待总经理审核",
  // 2220: "待产品确认",
  2230: "待成本核算",
};

// 商务申请有效期限
const timeLimit = {
  10: "一次有效",
  20: "自定义期限",
  30: "永久有效",
};

//------------------------------以下部分请勿改动------------------------------

//转化为object和options
for (let key in exportObj) {
  let value = exportObj[key];
  if (Array.isArray(value)) {
    let options = [];
    let object = {};
    value.forEach((item) => {
      let itemArr = item.split(":");
      let option = {
        value: itemArr[0],
        label: itemArr[1],
      };
      object[option.value] = option.label;
      options.push(option);
    });
    value.$options = options;
    value.$object = object;
  }
}

export default {
  exportObj,
  toSelect,
  inspectionPercentage,
  inspectionStation,
  inspectionType,
  inspectionMethod,
  parentName,
  departmentName,
  category,
  deliveryType,
  flowName,
  customerTypeName,
  status,
  purchaseStatus,
  gender,
  receiveStatus,
  receive,
  urgencyType,
  faultDealMethod,
  dealMethod,
  result,
  reportOrderStatus,
  purchaseOrderStatus,
  productionStatus,
  productionOrderMaterialStatus,
  currentStatus,
  sapDeliveryStatus,
  snType,
  snStatus,
  nameplateType,
  materialSnStatus,
  mesStatus,
  salesOrderType,
  deliveryStatus,
  checkStatus,
  checksStatus,
  colorType,
  approvalStatus,
  classes,
  employmentType,
  isScrap,
  moveType,
  range,
  BusinessApplicationStatus,
  CREDIT_GROUP,
  systemIds,
  customerGroup,
  customerType,
  customerLevel,
  salesOrderStatus,
  timeLimit,
  repealStatus,
};
